import {
  BrandVariants,
  createDarkTheme,
  createLightTheme,
  Theme,
} from "@fluentui/react-components";
import { designTokens } from "./designTokens";

export { default, designTokens } from "./designTokens";

const aimsAccentBrand: BrandVariants = {
  10: "#e6fffa",
  20: "#b2f5ea",
  30: "#81e6d9",
  40: "#4fd1c5",
  50: "#38b2ac",
  60: "#039fb8",
  70: "#028a9f",
  80: "#026e7f",
  90: "#025763",
  100: "#014551",
  110: "#013842",
  120: "#012b33",
  130: "#011f24",
  140: "#001418",
  150: "#000a0c",
  160: "#000000",
};

export const aimsLightTheme: Theme = {
  ...createLightTheme(aimsAccentBrand),

  fontFamilyBase: designTokens.fontFamily,
  fontFamilyMonospace: "'Consolas', 'Courier New', monospace",
  fontFamilyNumeric: designTokens.fontFamily,

  fontSizeBase200: designTokens.fontSize.xs,
  fontSizeBase300: designTokens.fontSize.sm,
  fontSizeBase400: designTokens.fontSize.base,
  fontSizeBase500: designTokens.fontSize.lg,
  fontSizeBase600: designTokens.fontSize.xl,

  fontWeightRegular: designTokens.fontWeight.normal,
  fontWeightMedium: designTokens.fontWeight.medium,
  fontWeightSemibold: designTokens.fontWeight.semibold,
  fontWeightBold: designTokens.fontWeight.bold,

  lineHeightBase100: "14px",
  lineHeightBase200: "16px",
  lineHeightBase300: "20px",
  lineHeightBase400: "22px",
  lineHeightBase500: "28px",
  lineHeightBase600: "32px",

  borderRadiusNone: "0",
  borderRadiusSmall: designTokens.borderRadius.sm,
  borderRadiusMedium: designTokens.borderRadius.md,
  borderRadiusLarge: designTokens.borderRadius.lg,
  borderRadiusXLarge: designTokens.borderRadius.xl,
  borderRadiusCircular: designTokens.borderRadius.full,

  colorNeutralForeground1: designTokens.neutral[900],
  colorNeutralForeground2: designTokens.neutral[600],
  colorNeutralForeground3: designTokens.neutral[500],
  colorNeutralBackground1: "#ffffff",
  colorNeutralBackground2: designTokens.neutral[50],
  colorNeutralBackground3: designTokens.neutral[100],
  colorNeutralStroke1: designTokens.neutral[200],
  colorNeutralStroke2: designTokens.neutral[200],

  spacingHorizontalNone: "0",
  spacingHorizontalXXS: designTokens.spacing[1],
  spacingHorizontalXS: designTokens.spacing[2],
  spacingHorizontalSNudge: designTokens.spacing[3],
  spacingHorizontalS: designTokens.spacing[4],
  spacingHorizontalM: designTokens.spacing[5],
  spacingHorizontalL: designTokens.spacing[6],
  spacingHorizontalXL: designTokens.spacing[8],
  spacingHorizontalXXL: designTokens.spacing[10],
  spacingHorizontalXXXL: designTokens.spacing[12],

  spacingVerticalNone: "0",
  spacingVerticalXXS: designTokens.spacing[1],
  spacingVerticalXS: designTokens.spacing[2],
  spacingVerticalSNudge: designTokens.spacing[3],
  spacingVerticalS: designTokens.spacing[4],
  spacingVerticalM: designTokens.spacing[5],
  spacingVerticalL: designTokens.spacing[6],
  spacingVerticalXL: designTokens.spacing[8],
  spacingVerticalXXL: designTokens.spacing[10],
  spacingVerticalXXXL: designTokens.spacing[12],

  colorBrandBackground: designTokens.accent[500],
  colorBrandBackgroundHover: designTokens.accent[600],
  colorBrandBackgroundPressed: designTokens.accent[700],
  colorBrandBackgroundSelected: designTokens.accent[600],
  colorBrandBackgroundInvertedHover: designTokens.semantic.infoLight,
  colorBrandBackgroundInvertedSelected: designTokens.accent[500],
  colorBrandBackgroundInvertedPressed: designTokens.accent[600],

  shadow2: designTokens.shadow.sm,
  shadow4: designTokens.shadow.base,
  shadow8: designTokens.shadow.md,
  shadow16: designTokens.shadow.lg,
  shadow28: designTokens.shadow.xl,
  shadow64: designTokens.shadow["2xl"],
};

export const aimsDarkTheme: Theme = createDarkTheme(aimsAccentBrand);
